import axios from "axios";
import secureLocalStorage from "react-secure-storage";

export const get_all_notification = async (page, per_page) => {
    const response = await axios.post(
        `${secureLocalStorage.getItem("baseURL")}/api/get-all-notifications`,
        {
            per_page,
            page
        }
    );
    return response.data;
}
export const get_all_unread_notifications = async () => {
    const response = await axios.post(`${secureLocalStorage.getItem("baseURL")}/api/unread-notifications`)
    return response.data;
}
export const get_read_notification = async (id) => {
    let response = await axios.post(`${secureLocalStorage.getItem("baseURL")}/api/read-notification/` + id);
    return response.data;
  }